import { PRODUCT_COMBINATIONS_FETCH } from 'src/constants/actionTypes';
import { get } from 'src/actions/actionCreators';

/**
 * @deprecated Instead use graphql. See SC#60251
 */
export const fetchProductCombinations = () =>
  get(PRODUCT_COMBINATIONS_FETCH, '/product/combination');
